module.exports = {
	message: {
        // 阿拉伯语
		home: {
			language: "العربية",
			keyword:'كلمة أساسية',
			hotPro:'منتجات البيع الساخن',
			product:'المنتجات الرئيسية',
			about:'عنا نحن',
			aboutDesc:'خدمة العملاء، إرضاء العملاء',
			news:'آخر الأخبار',
			company:'الشركة',
			proVideo:'فيديو ترويجي',
			certificate:'التصديق',
			factory:'مصنع تعاوني'
		},
		about:{
			advantages:'قوتنا',
			factory:'عرض المصنع',
			honors:'الجوائز والشهادات',
			honorsDesc:'نحن نتابع هدفها في خدمتك بشكل أفضل',
			title1:'القدرة الإنتاجية',
			content1:'مملوكة بالكامل، ضخمة، مصنع إنتاج حديث',
			title2:'السعر التنافسي',
			content2:'سعر معقول، أداء عالي التكلفة',
			title3:'التسليم الفوري',
			content3:'العديد من المستودعات تقع في ميناء التحميل الرئيسي',
			title4:'الفريق المهني',
			content4:'فريق التطوير والإنتاج والتصدير المهني',
			free1:'الخدمات المخصصة',
			frcon1:'تشير إعادة تدوير المعادن إلى المعالجة المادية أو الميكانيكية للمواد المفيدة المفصولة عن الخردة المعدنية إلى منتجات معاد تدويرها. إنها سلسلة صناعية من إعادة التدوير، التفكيك إلى إعادة التدوير. وقد شكلت صناعة إعادة تدوير المعادن سلسلة صناعية كاملة ونظام بيئي لإعادة التدوير. ومع تبني الاقتصادات الناشئة تدريجيا لتكنولوجيات وأساليب حياة مماثلة لتلك الموجودة في بلدان منظمة التعاون والتنمية في الميدان الاقتصادي، سيصل الطلب العالمي على المعادن في المستقبل إلى ثلاثة إلى تسعة أضعاف كمية المعادن المستخدمة في جميع أنحاء العالم. ويمكن لإعادة تدوير المنتجات المعدنية المعقدة أن تحل التحديات الناجمة عن الزيادة الكبيرة في الطلب على المعادن وأن تتغلب عليها.',
			free2:'مراقبة الجودة',
			frcon2:'تشمل معدات إعادة تدوير المعادن أساساً معدات السحق والسحق، ومعدات الفرز، ومعدات المعالجة المسبقة، ومعدات المعالجة بالتجديد، وما إلى ذلك. تلعب المعدات المختلفة دورًا رئيسيًا في الروابط المختلفة لإعادة تدوير المعادن. وتستخدم هذه المعدات على نطاق واسع في معالجة الخردة المعدنية وتحسين استخدام الموارد، بما يشمل مجموعة متنوعة من الوسائل التقنية مثل السحق المادي والفصل المغنطيسي والتسطيح وما إلى ذلك.',
			free3:'محطة واحدة للخدمات اللوجستية',
			frcon3:'ويتخصص مركز إعادة تدوير المعادن التابع لمصنع شركتنا في معالجة جميع أنواع النفايات المعدنية ويلتزم بإعادة تدوير وتكرير المعادن النادرة. ويغطي نطاق إعادة التدوير في المتاجر العالم، ويوفر خدمات مريحة مثل تحليل الأسعار الفوري والمعاملات النقدية. تركز شركتنا على النفايات المعدنية عالية المحتوى (90%)، والتي يمكن إعادة تدويرها بغض النظر عن الوزن أو الشكل.',
			free4:'التفتيش من طرف ثالث',
			frcon4:'بالإضافة إلى التأثير البيئي لتعدين وصهر المعادن، فإنها تستهلك أيضا من 7 ٪ إلى 8 ٪ من إمدادات الطاقة في العالم. وتستهلك إعادة التدوير طاقة أقل مما يستهلكه الإنتاج الأولي للمعادن، بينما تقلل من التأثير العام على مواقع التعدين. كما أن إعادة تدوير المعادن يمكن أن تقلل من الطلب على الخامات المنخفضة الجودة، مما يحول دون استخراج بعض المعادن الثمينة التي ستكون نادرة في المستقبل.',
			new1:'الأخبار',
			new2:'أخبار الشركة',
			new3:'أخبار الصناعة'
		},
		service:{
			ourservice:'خدماتنا',
			questions:'الأسئلة الشائعة',
			message:'ترك رسالة',
			hours:'أرجوك لا تتردد في ترك رسالة سنرد عليك بعد 24 ساعة',
			name:'اسمك:',
			mail:'البريد الإلكتروني:*',
			tel:'هاتف/واتس أب:',
			type:'نوع المنتج:*',
			video:'الفيديو',
			up:'الصفحة الأولى',
			next:'الصفحة التالية'
		},
		contact:{
			help:'نحن هنا للمساعدة',
			helpDesc:'اتصل بنا من خلال معلومات الاتصال التالية',
			manager:'مدير مبيعات',
			phone:'الهاتف/واتس أب/ويتشات',
			sendeamil:'إرسال بريد إلكتروني',
			ouraddress:'عنواننا'
		}, 
		foot:{
			navigation:'التجوال السريع',
			type:'الفئات',
			mobile:'موبيل (ما هو التطبيق/الڤيكات)',
			email:'البريد الإلكتروني',
			address:'العنوان',
			number:'رقم الملف',
			service:'خدمة إيقاف واحد، اختيار أسهل'
		},
		product:{
			description:'الوصف',
			technical:'المواصفات الفنية',
			advantages:'المزايا',
			related:'المنتجات ذات الصلة',
			videoDesc:'مصنع سبائك الحديد في المصدر الصيني، وهو أعلى جودة في العالم وأدنى سعر، والعمولات العالية، يستعين بالوكيل.',
			ti1:'الرجاء ملء عنوان البريد الإلكتروني.',
			ti2:'الرجاء ملء النوع.',
			ti3:'الرجاء ملء المحتوى.'
		},
		nav:{
			home:'المنزل',
			about:'بشأننا',
			products:'المنتجات',
			news:'الأخبار',
			video:'الفيديو',
			free:'إعادة التدوير والتكنولوجيا الحرة',
			contact:'اتصل بنا',
			vr:'VR',
			chat:'دردشة',
			whatsapp:'ما هو التطبيق',
			wechat:'الويتشات',
			message:'الرسالة',
			tel:'هاتف',
			top:'الجزء العلوي',
		},
		btn:{
			read:'اقرأ المزيد',
			news:'المزيد من الأخبار',
			exhibition:'المزيد من المعلومات',
			watchVideo:'شاهد المزيد من الفيديوهات',
			services:'الخدمات',
			products:'المنتجات',
			contactus:'اتصل بنا',
			inquiry:'استفسروا الآن',
			size:'الحجم',
			packing:'التعبئة',
			service:'الخدمة عبر الإنترنت',
			submit:'التقديم',
			sendEmial:'أرسل البريد الإلكتروني',
			now:'اطلب الآن',
			text1:'لا تتردد في الاتصال بنا في أي وقت',
			text2:'نحن نصمم محتوى وتفصيل المواد التي تلبي احتياجاتك.',
			text3:'وسواء كنت في حاجة إلى زيادة السلامة، أو تعظيم القدرة الإنتاجية أو الموثوقية، أو خفض التكاليف، فإننا نقوم بالإنجاز.',
			text4:'نحن نكرس أنفسنا لتقديم خدمة استثنائية للعملاء وتقديم منتجات عالية الجودة لعملائنا القيمين.',
			text5:'التركيز على إنتاج الحديد والسيليكون والمعادن السليكون عالية الجودة',
			text6:'* النصائح: 1. ما المنتج الذي تحتاج إليه؟ 2. اي مشروع تنوي القيام به؟ 3. متى ستحتاجين هذا المنتج؟'
		}
    }
};
